export default __webpack_public_path__ + "static/media/icons8-user-shield-48.51373360.svg";